import React from 'react';

import { Body } from 'components/text';

import styles from './ArticleInfoItem.module.scss';
import { ArticleInfoItemProps } from './types';

const ArticleInfoItem: React.FC<ArticleInfoItemProps> = ({
  detail,
  showEllipse = true,
}) => {
  return (
    <>
      {showEllipse && <div className={styles.ellipse}></div>}
      <Body color="grey-dark">{detail}</Body>
    </>
  );
};

export default ArticleInfoItem;
